const I18nSelectors = {
  getLanguage(store) {
    return store.i18n.language;
  },
};

export { I18nSelectors };
